import { type CompetitionQnA } from '@app/client';

const htp =
    'Yat Fantasy is a free to play fantasy NFT trading game where you build a lineup of NFT collections and compete against other players to see who can get the most profit.\n' +
    'Players who end the game in profit will earn real cash rewards. Additionally, for every three game streak you play, you’ll earn a cash reward.\n' +
    'Each Yat Fantasy game lasts one week before rolling over into the next game where your profits will be reset and the competition begins again.';
const htpSimple =
    '#### Playing Yat Fantasy is simple:\n' +
    '\n' +
    '- Add collections to your lineup by buying them with your fantasy money\n' +
    '- Sell collections when you want to secure profit, or continue to hold them if you think they’ll keep climbing in value\n' +
    '- Trade your way to profitable status to earn real cash rewards';

const htpTips =
    '#### Some helpful tips:\n' +
    '\n' +
    '- Building a lineup\n' +
    '  - If you haven’t played before, you can automatically create a lineup using our landing page at https://y.at/fantasy-games\n' +
    '  - You can use the “Recently picked” and “Fresh ideas” feeds for ideas around what collections to add\n' +
    '  - You can check the leaderboard and look at what top players are adding to their lineup\n' +
    '- Playing on a team\n' +
    '  - Playing on a team will give you access to additional team rewards and features\n' +
    '  - You can invite people to your team using your personal invite code, or join an existing team if you have their invite link\n' +
    '- Getting to profit\n' +
    '  - There are many resources you can use to find profitable collections. Here are a few of our favorites:\n' +
    '  - Yat Holder Activity Feeds: Go to y.at and search for a collection where you want to see what holders are doing. Look at “Buys” in the Holder Activity feed to see what those collectors are buying which you may want to long, or “Sales” to see what they’re selling which you may want to short.\n' +
    '    - Blur: Go to blur.io, click on “Collections” and then “Trending”\n' +
    '    - OpenSea: Go to opensea.io, click on “Stats” and then “Trending”\n' +
    '  - Make sure you capitalize on both Long and Short plays. Shorting is essentially a bet that an asset will go down in value, whereas when you buy an asset but don’t short you are “long”, betting it will go up in value.\n' +
    '  - Get in touch with our community\n' +
    "    We have a very helpful community at [discord.gg/yatfantasy]('discord.gg/yatfantasy') who can help you learn the ropes!\n";

const reviewAnswer =
    '1. NFT Collections for which floor listings are not fulfillable/can not be purchased. These collections will be placed under review and potentially disqualified unless the floor listing becomes purchasable.\n' +
    '\n' +
    '2. Any old contracts of an NFT collection which have a public record of migrating to a new contract and still have active listings. Collections under these contracts will be disqualified.\n' +
    '\n' +
    '3. Floor prices of NFT collections manipulated by tokens that have a history of being flagged as stolen or suspicious by one or more marketplaces. These collections will be disqualified.\n' +
    '\n' +
    '4. NFT collections which are flagged by any marketplace as suspicious or fraudulent. These collections will be disqualified We will re evaluate reports as they occur to consider additional changes, and hold the right to disqualify any collection or player at any given time for any reason.\n';

const supportAnswer =
    'You can ask questions on our [Discord](http://discord.gg/yatfantasy) channel, open a ticket in the discord server, or contact [support@y.at](mailto:support@y.at). When emailing or submitting a ticket, please include your Twitter handle or email on your account when you contact us.\n';
export const howToPlay: CompetitionQnA = {
    question: 'How to Play',
    answers: [htp, htpSimple, htpTips],
};

export const defaultFaqItems: CompetitionQnA[] = [
    {
        question: 'What is the point of Yat Fantasy?',
        answers: [
            'Our intent is to help people explore the blockchain space and assets within it in a totally risk-free environment, and offer a fun and engaging experience for people to learn about and test out trading these assets.',
        ],
    },
    {
        question: 'Is there any purchase necessary to win?',
        answers: ['No, Yat Fantasy is completely free to play at this time.'],
    },
    {
        question: 'Can I enter Yat Fantasy more than once per game?',
        answers: [
            'No, each Yat Fantasy player is only allowed one entry per game at this time. Multiple entries will be grounds for disqualification.',
        ],
    },
    {
        question: 'How can I create or join a Yat Fantasy team?',
        answers: [
            'Your team status can be managed via the “My Team” tab on any Yat Fantasy game page. Here you can do things like create a team, find your team invite link which you can send to other players, or view information about a team you are on.',
        ],
    },
    {
        question: 'Are there prizes or benefits for playing on a Yat Fantasy team?',
        answers: [
            'Yes, teams are eligible to compete for an entirely separate prize pool. When a team wins the teams prize, they split the prize pool amongst team members. Additionally, playing on a team is way more fun! You can strategize with your team members and converse with other teams to make friends or pour on the salt.',
        ],
    },
    {
        question: 'Why are some assets ineligible to be added to my lineup?',
        answers: [
            'Yat Fantasy has certain criteria we judge assets based off of to ensure fair gameplay, and as such certain assets may be ineligible either across all games or during specific games. This depends on things like the volume of the asset, number of holders, and other qualifying factors.',
        ],
    },
    {
        question: 'For what reasons might an asset be banned or put under review?',
        answers: [reviewAnswer],
    },
    {
        question: 'How do I report a suspicious collection?',
        answers: [
            'If you see a collection with suspicious activity like floor price manipulation or a bugged contract affecting the game, please get in touch with a Yat staff member via the Yat Fantasy Discord or support@y.at. Not all collections reported will result in a review period or be banned but we will consider all reports.',
        ],
    },
    {
        question: 'Do I need to own cryptocurrency or NFTs to play?',
        answers: [
            'No, you do not need to own any cryptocurrency or NFTs to play Yat Fantasy. It is completely free to play, and anyone can join and have fun regardless of your knowledge or experience.',
        ],
    },
    {
        question: 'Can I make changes to my lineup after the game begins?',
        answers: [
            'Yes, you’ll be able to make as many changes to your lineup as you like throughout the game. We find the more active a player is in making adjustments to their lineup, the better they perform!',
        ],
    },
    {
        question: 'Why did I lose some of my portfolio value when changing my lineup?',
        answers: [
            'The most likely reason for this is that currently Yat Fantasy has a strict “use it or lose it” policy. If you make a change but don’t use your entire portfolio value, you will lose whatever was left over.',
        ],
    },
    {
        question: 'If I win, how do I collect my prize?',
        answers: [
            'We will reach out to all winners at each game’s conclusion to let them know they are eligible to collect a prize, along with the process required to collect. Please note you will have 5 days from the time we reach out to begin the prize collection process or you will forfeit your prize.',
        ],
    },
    {
        question: 'Are Yat Labs, LLC employees eligible to win prizes?',
        answers: [
            'No. While many Yat employees do play Yat Fantasy, to keep things transparent and fair we do not allow Yat employees to win prizes. They are rewarded with the joy of our player base (and of course, salaries)!',
        ],
    },
    {
        question: 'I need more help, what should I do?',
        answers: [supportAnswer],
    },
];
